// extracted by mini-css-extract-plugin
export default {"imageSelector":"V0deH21V26v_IjgOggMg","frames":"J_2DsUlgAHD9CttywflW","frameBorder":"PkoHFJDx4D4cMwVX7g9I"};